import React, { useMemo, useState } from 'react';
import { TreeMultiSelectFilter } from '@ui';
/**
 * Adapts `TreeMultiSelectFilter` to a Rails array parameter, for both license
 * scoping fields — Trade (IP-15528) and State/Province (IP-15386).
 *
 * `TreeMultiSelectFilter` is a filter-bar control: it reports selection through
 * `onChange` and emits no form inputs of its own. This mirrors the selection
 * into hidden inputs so a Rails form can submit it.
 *
 * The leading blank input matters. Rails does the same thing for
 * `select multiple`: without it, clearing every value would submit no key at
 * all, so `update` would leave the previous value in place instead of clearing
 * it. `License#normalize_scoping` drops the blank member.
 */
function LicenseMultiSelectField({ name, label, initialValue = [], options, nonSelectableValues = [], emptyHint, className = 'license-multi-select-field' }) {
    const [value, setValue] = useState(initialValue);
    const hiddenInputs = useMemo(() => value.filter((entry) => entry !== ''), [value]);
    return (React.createElement("div", { className: className },
        React.createElement("input", { type: "hidden", name: name, value: "", autoComplete: "off" }),
        hiddenInputs.map((entry) => (React.createElement("input", { key: entry, type: "hidden", name: name, value: entry, autoComplete: "off" }))),
        React.createElement(TreeMultiSelectFilter, { field: name, label: label, value: value, onChange: setValue, options: options, nonSelectableValues: nonSelectableValues }),
        emptyHint != null && value.length === 0 && React.createElement("em", { className: "--empty-msg" }, emptyHint)));
}
export default LicenseMultiSelectField;
